var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 4.99954V2.20954C12 1.75954 11.46 1.53954 11.15 1.85954L7.35003 5.64954C7.15003 5.84954 7.15003 6.15954 7.35003 6.35954L11.14 10.1495C11.46 10.4595 12 10.2395 12 9.78954V6.99954C15.73 6.99954 18.68 10.4195 17.86 14.2895C17.39 16.5595 15.55 18.3895 13.29 18.8595C9.72003 19.6095 6.54003 17.1595 6.06003 13.8495C5.99003 13.3695 5.57003 12.9995 5.08003 12.9995C4.48003 12.9995 4.00003 13.5295 4.08003 14.1295C4.70003 18.5195 8.88003 21.7695 13.61 20.8495C16.73 20.2395 19.24 17.7295 19.85 14.6095C20.84 9.47954 16.94 4.99954 12 4.99954Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.065122065eb3baa8ca85dcee6954f8a3.svg";
export { ForwardRef as ReactComponent };